import {AfterViewInit, Component, OnInit} from '@angular/core';
import {LayoutManagerService} from '../../layout-manager.service';

declare  var jQuery:  any;

@Component({
  selector: 'app-about-us-content',
  templateUrl: './about-us-content.component.html',
  styleUrls: ['./about-us-content.component.css']
})
export class AboutUsContentComponent implements OnInit, AfterViewInit {

  layoutManager

  constructor(
     layoutManager: LayoutManagerService
  ) {
    this.layoutManager = layoutManager
  }


  ngOnInit() {
    window.scroll(0,0)
  }

  redirectContacts() {
    window.open("/contattaci", "_blank");
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  ngAfterViewInit(){
    ( function ( $ ) {
      "use strict";
      var carousel = $( ".carousel" );
      function doAnimations( elems ) {
        console.log('loadpage2');
        //Cache the animationend event in a variable
        var animEndEv = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elems.each( function ( ) {
          var $this = $( this ),
            $animationType = $this.data( 'animation' );
          $this.addClass( $animationType ).one( animEndEv, function ( ) {
            $this.removeClass( $animationType );
          } );
        } );
      }

      //Variables on page load
      var $firstAnimatingElems = carousel.find( '.carousel-item:first' ).find( "[data-animation ^= 'animated']" );
      //Initialize carousel
      carousel.carousel( );
      //Animate captions in first slide on page load
      doAnimations( $firstAnimatingElems );
      console.log('firstload');
      //Other slides to be animated on carousel slide event
      carousel.on( 'slide.bs.carousel', function ( e ) {
        var $animatingElems = $( e.relatedTarget ).find( "[data-animation ^= 'animated']" );
        doAnimations( $animatingElems );
      } );
    } )( jQuery );


    // CODE 2 for static-slider 2



  }

}
